import { BaseButton } from "../styles/ButtonStyles";
import CircleImage from "./circleImage";
import styled from "styled-components";

const ButtonCancel = styled(BaseButton)`
    margin-right:25px;
    background-color:#d7d7d7;
`;

const ReviewPage = (props) => {
    const approvedRefs = props.approvedRefs || [];
    const approveLabel = props.approveLabel || 'Approve';
    const rejectLabel = props.rejectLabel || 'Disapprove';
    const inappropriateLabel = props.inappropriateLabel || 'Inappropriate';
    function getSelectedPhotoFromArray(photosArray) {
        if (!photosArray) {
            return null;
        }

        for (const photoObj of photosArray) {
            if (photoObj.selected === true) {
                return photoObj.photo;
            }
        }

        if (photosArray.length > 0) {
            return photosArray[0].photo;
        }
        return null;
    }

    function getReviewPhoto(profile) {
        if (props.tabType === 'people') {
            return getSelectedPhotoFromArray(profile.photos);
        }

        if (props.tabType === 'autofeed') {
            const selectedPhotoset = profile.selectedPhotoset || 'updated_images';
            return getSelectedPhotoFromArray(profile[selectedPhotoset]);
        }

        return getSelectedPhotoFromArray(profile.updated_images);
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
            <div style={{ flex: 2, textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <span style={{ alignSelf: 'center', color: '#767676', fontFamily: 'Gilory-Semi', fontSize: '20px', fontWeight: '800', lineHeight: 'normal' }}>{inappropriateLabel}</span>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
                    {
                        props.inappProfiles.map((image_name, index) => {
                            return (
                                <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', margin: '10px' }}>
                                    <CircleImage src={getReviewPhoto(image_name)} />
                                    <p>{image_name.first_name}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <hr style={{ width: '100%', margin: '10px 0' }} />
            <div style={{ flex: 2, textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <span style={{ alignSelf: 'center', color: '#767676', fontFamily: 'Gilory-Semi', fontSize: '20px', fontWeight: '800', lineHeight: 'normal' }}>{approveLabel}</span>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
                    {
                        props.likes.map((image_name, index) => {
                            return (
                                <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', margin: '10px' }}>
                                    <CircleImage src={getReviewPhoto(image_name)} isApproved={approvedRefs.includes(image_name.ref)} />
                                    <p>{image_name.first_name}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <hr style={{ width: '100%', margin: '10px 0' }} />
            <div style={{ flex: 2, textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <span style={{ alignSelf: 'center', color: '#767676', fontFamily: 'Gilory-Semi', fontSize: '20px', fontWeight: '800', lineHeight: 'normal' }}>{rejectLabel}</span>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
                    {
                        props.passed.map((image_name, index) => {
                            return (
                                <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', margin: '10px' }}>
                                    <CircleImage src={getReviewPhoto(image_name)} />
                                    <p>{image_name.first_name}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            {
                props.ban.length > 0 &&
                <>
                    <hr style={{ width: '100%', margin: '10px 0' }} />
                    <div style={{ flex: 2, textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        <span style={{ alignSelf: 'center', color: '#767676', fontFamily: 'Gilory-Semi', fontSize: '20px', fontWeight: '800', lineHeight: 'normal' }}>Ban</span>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
                            {
                                props.ban.map((image_name, index) => {
                                    return (
                                        <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', margin: '10px' }}>
                                            <CircleImage src={getReviewPhoto(image_name)} />
                                            <p>{image_name.first_name}</p>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </>
            }
            <div style={{ flex: 1, textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <ButtonCancel onClick={() => props.cancel()}>Cancel</ButtonCancel><BaseButton onClick={() => props.save()}>Save</BaseButton>
            </div>
        </div>


    );
};


export default ReviewPage;
